<template>
   <div class='chart-box-out'>
        <div class='chart-back'></div>
        <div class='chart-container'>
            <slot></slot>
            <div class='corner corner-top-left'>
                <div class='left-line'></div>
                <div class='top-line'></div>
            </div>
            <div class='corner corner-top-right'>
                <div class='top-line'></div>
                <div class='right-line'></div>
            </div>
            <div class='corner corner-bottom-left'>
                <div class='bottom-line'></div>
                <div class='left-line'></div>
            </div>
            <div class='corner corner-bottom-right'>
                <div class='bottom-line'></div>
                <div class='right-line'></div>
            </div>
        </div>
    </div>
</template>

<script>

export default{

}
</script>
<style  scoped>
.chart-box-out{
    position:relative;
    width:100%;
    height:100%;
}
.chart-back{
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background:#164d99;
    opacity:0.05;
}
.chart-container {
    width: 100%;
    height: 100%;
    position: relative;
    border: 1px solid #8098dc;
}

.corner {
    position: absolute;
    width: 28px;
    height: 28px;
}

.corner-top-left {
    left: -2px;
    top: -2px;
}

.corner-top-right {
    top: -2px;
    right: -2px;
}

.corner-bottom-left {
    bottom: -2px;
    left: -2px;
}

.corner-bottom-right {
    bottom: -2px;
    right: -2px;
}

.left-line {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 3px;
    height: 100%;
    background-color: #0EFCFF;
}

.top-line {
    position: absolute;
    left: 0;
    top: 0;
    height: 3px;
    width: 100%;
    background-color: #0EFCFF;
}

.right-line {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 3px;
    height: 100%;
    background-color: #0EFCFF;
}

.bottom-line {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    width: 100%;
    background-color: #0EFCFF;
}
</style>
